module.exports = __webpack_public_path__ + "static/bottle-dunkin-vanilla-extra-extra-32oz-fc654056990151c08267f38a9dfe8bf0.png";